import {Model} from "@/models/model";
import {reactive} from "vue";
import {restApiHttpClient} from "@/helpers/rest-api-http-client";
import {useStore} from '@/helpers/store-effect';

const store = useStore();

export class Connection extends Model {

}

export class ConnectionsService {
    constructor() {
        this.providers = reactive({});
        for (const provider in store.connections) {
            for (const connectionUid in store.connections[provider]) {
                store.connections[provider][connectionUid] = new Connection(store.connections[provider][connectionUid]);
            }
        }
        this.connections = reactive(store.connections);
    }

    registerProvider(provider) {
        this.providers[provider.id] = provider;
        this.connections[provider.id] = this.connections[provider.id] || reactive({});
    }

    getProvider(providerId) {
        return this.providers[providerId] || null;
    }

    connectWithProvider(providerId) {
        return new Promise(async (resolve, reject) => {
            try {
                const provider = this.getProvider(providerId);
                const connectionDefination = await provider.connect();
                const connection = await this.persistConnection(provider, connectionDefination).then(response => new Connection(response.data));
                this.connections[providerId][connection.uid] = connection;
                resolve(connection);
            } catch (e) {
                reject(e);
            }
        });
    }

    getConnections(providerId) {
        return this.connections[providerId] || {};
    }

    getConnection(providerId) {
        return this.connections[providerId] || {};
    }

    async persistConnection(provider, connection) {
        return await restApiHttpClient.post(`connections`, {provider: provider.id, connection});
    }
}

const connectionsService = new ConnectionsService();

export function useConnections() {
    return connectionsService;
}
